import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fb7001b0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb7001b0')) {
      api.createRecord('fb7001b0', component.options)
    } else {
      api.reload('fb7001b0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fb7001b0", function () {
      api.rerender('fb7001b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/contratadas/index.vue"
export default component.exports